<template lang="pug">
  v-list(dense)
    v-list-tile
      v-list-tile-avatar
        v-avatar(:size='22', color='grey lighten-4')
          img(src='https://cdn3.iconfinder.com/data/icons/avatar-set/512/Avatar01-512.png', alt='avatar')
      v-list-tile-content(:title="$t('messages.patientsNameAndPatID')")
        v-list-tile-title.list-dense(:title="patient.name") {{patient.name}}
        small.text-truncate.grey--text.text--darken-1 {{patient.birthdate ? patient.birthdate : null | ageFriendly}} {{ patient.patId }}
      v-list-tile-action
        v-btn(icon, @click="dialogPatient = !dialogPatient")
          v-icon(small, color='primary') edit
    v-divider(inset)
    template(v-if="gestationInteraction.forms")
      v-list-tile
        v-list-tile-avatar
          v-icon(color='pink') fas fa-calendar
        v-list-tile-content(:title="$t('messages.studyDate')")
          v-list-tile-title.list-dense {{gestationInteraction.date | formatDateExtend}}
          small.grey--text.text--darken-1 {{ $t('messages.studyDate') | capitalize }}
      v-divider(inset)
      v-list-tile
        v-list-tile-avatar
          v-icon(color='green') fas fa-calendar-alt
        v-list-tile-content(title="Idade gestacional")
          v-list-tile-title.list-dense {{ gestationInteraction.forms['gestationalAge.info.date'] ? gestationInteraction.forms['gestationalAge.info.calculada'] : '' | weeksAndDays }}
          small.grey--text.text--darken-1 {{ gestationInteraction.forms['gestationalAge.info.calculo'] === 'manual' ? `${ $t(gestationAgeCalculoText) } (${ gestationInteraction.forms['gestationalAge.info.calculoRef'] })` : $t(gestationAgeCalculoText) }}
        v-list-tile-action
          v-btn(icon, :to="{name: 'Ultra Fetal Form', params: { formId: 'gestationalAge' }}")
            v-icon(small, color='primary') edit
      v-divider(inset)
      v-list-tile
        v-list-tile-avatar
          v-icon(color='blue') fas fa-child
        v-list-tile-content(title="Idade Gestacioal")
          v-list-tile-title.list-dense(:title="$t('messages.predictionOfLabor')") {{previsaoParto | formatDateExtend}}
          small.grey--text.text--darken-1 {{ $t('messages.predictionOfLabor') | capitalize }}
      v-divider(inset)
    UfPatient(v-model="dialogPatient", :iuid='patient.iuid')
</template>

<script>
import {mapState} from 'vuex'
import moment from 'moment'

import UfPatient from '@/components/ultra-fetal/home/Patient'

export default {
  name: '',

  components: {
    UfPatient
  },

  computed: {
    ...mapState({
      gestationInteraction: (state) => state.ultraFetal.gestationInteraction,
      patient: (state) => state.ultraFetal.patient
    }),
    previsaoParto () {
      if (this.gestationInteraction.forms && this.gestationInteraction.forms['gestationalAge.info.dateParto']) {
        return moment(this.gestationInteraction.forms['gestationalAge.info.dateParto'])
      } else if (this.gestationInteraction.forms && this.gestationInteraction.forms['gestationalAge.info.date']) {
        return moment(this.gestationInteraction.forms['gestationalAge.info.date']).add(280, 'days')
      } else {
        return ''
      }
    },
    gestationAgeCalculoText () {
      const calculoValue = this.gestationInteraction.forms['gestationalAge.info.calculo']
      return calculoValue ? `gestationalAge.info.calculo.items.${calculoValue}.text` : ''
    }
  },

  data () {
    return {
      dialogPatient: false
    }
  }
}
</script>

<style lang="stylus" scoped>
.list-dense
  height 18px
  line-height 24px
</style>



// WEBPACK FOOTER //
// src/components/ultra-fetal/home/PatientDetail.vue